import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngLoaderModule } from '../loader';
import { MatTooltipModule } from '@angular/material/tooltip';
import { KngItemCardComponent } from './kng-item-card.component';
import { RoundoffDecimalModule } from '../../pipes/roundoff-decimal/roundoff-decimal.module';

@NgModule({
	declarations: [KngItemCardComponent],
	imports: [ CommonModule, KngLoaderModule, MatTooltipModule, RoundoffDecimalModule ],
	exports: [KngItemCardComponent],
	providers: []
})
export class KngItemCardModule {}
